import Cookies from 'js-cookie';
import { getRootDomain } from '@/utils';
import { getConfig } from '../configProvider';
import { getSuffix } from './';

const getUIDKey = () => {
    return `ouid${getSuffix()}`;
};

/**
 * 海外版本不进行cookie存储
 */

/**
 * 初始化同步uid
 */
export const initLocalUid = () => {
    const { isIntl } = getConfig();

    if (isIntl) return;

    const uid = Cookies.get(getUIDKey());

    if (uid) {
        window.localStorage.setItem('uid', String(uid));
    } else {
        window.localStorage.removeItem('uid');
    }
};

/**
 * 更新本地uid缓存和cookie中的uid
 * @param uid
 */
export const setLocalUid = (uid: number) => {
    if (!uid) return;

    const { isIntl } = getConfig();

    if (!isIntl) {
        Cookies.set(getUIDKey(), String(uid), {
            domain: getRootDomain(),
            expires: 36500, // 100年有效期
        });
    }

    window.localStorage.setItem('uid', String(uid));
};

export const getLocalUid = () => {
    const data = window.localStorage.getItem('uid');
    return data ? Number(data) : null;
};

/**
 * 移除本地uid缓存和cookie中的uid
 */
export const removeLocalUid = () => {
    const { isIntl } = getConfig();

    if (!isIntl) {
        Cookies.remove(getUIDKey(), {
            domain: getRootDomain(),
        });
    }

    window.localStorage.removeItem('uid');
};
